import {BmAlertIcon} from "~/components/icons/simpleIcons";
import {designColors} from "~/ui";
import {commonStyles} from "~/components/banners/_common";

import {BmSimpleBaseInfoBanner, BmSimpleBaseInfoBannerProps} from "../../SimpleBaseInfoBanner";

export const BmSimpleErrorNotificationBanner: React.FC<BmSimpleBaseInfoBannerProps> = ({...restProps}) => {
  return (
    <BmSimpleBaseInfoBanner
      {...restProps}
      colorPreset="red"
      leftColumn={<BmAlertIcon id="alert-icon" color={designColors.colorInk} className={commonStyles.icon} size="xs" />}
    />
  );
};
